function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#33D5BA",
  d: "M19.531 1.563H2.344c-.622 0-1.218.246-1.658.686C.246 2.689 0 3.285 0 3.906v17.188c0 .621.247 1.217.686 1.657.44.44 1.036.686 1.658.686h6.701V16H5.97v-3.5h3.076V9.832c0-3.035 1.807-4.71 4.574-4.71 1.325 0 2.711.235 2.711.235v2.979h-1.527c-1.504 0-1.973.934-1.973 1.891V12.5h3.358l-.537 3.5H12.83v7.438h6.701c.622 0 1.218-.247 1.658-.687.44-.44.686-1.036.686-1.657V3.906c0-.621-.247-1.217-.686-1.657-.44-.44-1.036-.687-1.658-.687z"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0H21.875V25H0z"
})));
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 25,
    fill: "none",
    viewBox: "0 0 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.689340b6285abc0e62b7be22aba11c0d.svg";
export { ForwardRef as ReactComponent };